import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-28d26e59"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"color":"var(--el-color-primary)"} }
const _hoisted_2 = { style: {"text-align":"center"} }
const _hoisted_3 = { style: {"color":"var(--el-color-primary)","font-weight":"bold"} }
const _hoisted_4 = { style: {"text-align":"center"} }
const _hoisted_5 = { style: {"text-align":"center","margin":"20px 0","color":"var(--cm-color-text-secondary)"} }
const _hoisted_6 = {
  key: 0,
  class: "",
  style: {"width":"fit-content","margin":"0 auto","padding":"10px 10px 7px","border-radius":"var(--el-border-radius-large)","border":"1px solid var(--el-border-color-base, #cfcfcf)"}
}
const _hoisted_7 = {
  key: 1,
  style: {"width":"120px","height":"120px","display":"inline-flex","align-items":"center","justify-content":"center","background":"var(--cm-color-hover-bg)"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { style: {"text-align":"center"} }
const _hoisted_11 = { style: {"text-align":"center","margin":"0 0 30px 0","color":"var(--cm-color-text-secondary)","font-size":"14px"} }
const _hoisted_12 = {
  class: "cm-align-center",
  style: {"font-size":"14px","line-height":"normal","text-align":"center","justify-content":"center","align-items":"flex-start","color":"var(--cm-color-text-secondary)"}
}
const _hoisted_13 = {
  t: "1766482509751",
  class: "icon cm-ui-mr5",
  style: {"width":"16px","height":"16px","font-size":"14px","position":"relative","top":"2px","flex":"none"},
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7130",
  width: "48",
  height: "48"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M512 1024c-136.8 0-265.3-53.3-362-150C53.3 777.3 0 648.8 0 512s53.3-265.3 150-362C246.7 53.3 375.2 0 512 0s265.3 53.3 362 150c96.7 96.7 150 225.3 150 362 0 136.8-53.3 265.3-150 362-96.7 96.7-225.2 150-362 150z m0-979.5c-124.9 0-242.3 48.6-330.6 136.9C93.1 269.7 44.5 387.1 44.5 512s48.6 242.3 136.9 330.6c88.3 88.3 205.7 136.9 330.6 136.9 124.9 0 242.3-48.6 330.6-136.9 88.3-88.3 136.9-205.7 136.9-330.6 0-124.9-48.6-242.3-136.9-330.6C754.3 93.1 636.9 44.5 512 44.5z",
  style: {"fill":"var(--cm-color-text-secondary)"},
  "p-id": "7131"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M480.8 244.3c0 17.2 14 31.2 31.2 31.2s31.2-14 31.2-31.2-14-31.2-31.2-31.2-31.2 14-31.2 31.2zM512 810.9c-12.2 0-22.3-10-22.3-22.3V387.9c0-12.2 10-22.3 22.3-22.3 12.2 0 22.3 10 22.3 22.3v400.7c0 12.3-10.1 22.3-22.3 22.3z",
  style: {"fill":"var(--cm-color-text-secondary)"},
  "p-id": "7132"
}, null, -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

import StrategySetting from './components/strategy-setting.vue'
import { ref, reactive, onMounted, watch, nextTick, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'

import { PolicySettingType, PolicyType } from '@/views/dashboard/_enum/policy-type'
import { PermissionFe, ServicePermissionService } from '@/services/service-permission.service'
import PolicyManage from '@/views/dashboard/_components/policy-manage/policy-manage.vue'
import { TableOptColumn } from '@/components/cmTable/types'
import { GroupRefreshManage } from '@/services/group'
import { PolicyCommonService, StrategyListDataCommon } from '@/views/dashboard/policy/policy-common.service'
import TaskTimeShow from '@/views/dashboard/_components/task-time/task-time-show.vue'
import Keywords from '../data-safe/anti-external-control/components/Keywords.vue'
import { RemoteAuthLoginService, AuthLogItem, RequestParams, terminalStatTopRequestParams } from './service'
import { Auth_method, getAuthMethodLabel } from './types'
import QrcodeVue from 'qrcode.vue'
import dayjs from 'dayjs'
import TokenCode from './components/token-code.vue'
import RemoteAuthPolicyPasswordLink from './components/remote-auth-policy-password-link.vue'
import PageSubscribeBar from '@/views/dashboard/_components/subscribe-bar/page-subscribe-bar.vue'
import Card from '@/views/dashboard/_components/card/card.vue'
import StatisticsCards from './_components/statistics-cards.vue'
import LoginTrendChart from './_components/login-trend-chart.vue'
import LoginRankingChart from './_components/login-ranking-chart.vue'
import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import GroupTreeSelector from '../_components/group-tree-selector/group-tree-selector.vue'
import { TerminalType } from '../_enum/terminal-type'
import { useParseTime } from '@/hooks'
import { formatTimeStamp, getTimeRangeByEnum } from '@/utils/time'
import { TimeRange, TimeGranularity, TimeFormat } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import { formatMapToOptions } from '@/utils/tool'
import RemoteLoginLogList from '../manage/port-manage/_components/remote-login-log-list/remote-login-log-list.vue'
import { TableViewMode } from '@/views/dashboard/_enum/table-view-mode'
import {
  ActionType,
  ActionTypeValuesByKeys,
  DateType,
  FormActionType,
  FormSize,
  FormSizeType,
  FormType,
  ObjectFormItem,
} from '@/components/cmForm/types'
import { TableOpt } from '@/components/cmTable/types'
import { ElMessage } from 'element-plus'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, locale } = useI18n()
const injector = useReflectiveInjector([PolicyCommonService, RemoteAuthLoginService])
const groupRefreshManage = injector.get(GroupRefreshManage)
const remoteAuthLoginService = injector.get(RemoteAuthLoginService)
const groupPolicySettingsService = injector.get(PolicyCommonService)
const servicePermissionService = injector.get(ServicePermissionService)
const hasPermission = servicePermissionService.getHasPermission(PermissionFe.remote_control)

// 统计数据
const statistics = reactive({
  todayLoginCount: 0,
  todaySuccessCount: 0,
  todayFailedCount: 0
})

// 图表数据
const trendTimeRange = ref<TimeRange>(TimeRange.DAYS_30)
const rankingTimeRange = ref<TimeRange>(TimeRange.DAYS_30)
const rankingData = ref<
  Array<{
    name: string
    department: string
    count: number
    device_id?: string
    group_id?: string
  }>
>([])

const trendChartData = ref<{
  times: string[]
  success: number[]
  failed: number[]
}>({
  times: [],
  success: [],
  failed: []
})

// 日志相关
const remoteLoginLogListRef = ref()
const loginRankingChartRef = ref()
const logExportApi = remoteAuthLoginService.getTerminalUserLoginLogExport.bind(remoteAuthLoginService)
const formSize: FormSizeType = FormSize.Small
const selectedPolicyIds = ref<string[]>([])
// 编辑api
const saveOrUpdateApi = groupPolicySettingsService.saveSettings.bind(groupPolicySettingsService)
// 获取当前策略
const getApi = groupPolicySettingsService.getSettings.bind(groupPolicySettingsService)
// 绑定动态口令
const getStrategyRemoteLoginAuthBindDynamicPasswordApi = remoteAuthLoginService.getStrategyRemoteLoginAuthBindDynamicPassword.bind(remoteAuthLoginService)
// 刷新动态口令二维码
const getStrategyRemoteLoginAuthRefreshDynamicPasswordApi = remoteAuthLoginService.getStrategyRemoteLoginAuthRefreshDynamicPassword.bind(remoteAuthLoginService)
const visible = ref(false)
const visibleToken = ref(false)
const policyManageRef = ref()
const name = ref('')
const activeRow = ref({} as StrategyListDataCommon)
const fromGroupId = ref()
const bindUrl = ref('')
const lastUpdateTime = ref('--:--:--')
const qrcodeLoading = ref(false)
const refreshLoading = ref(false)
const currentStrategyId = ref('')
const authMethodLabel = computed(() => {
  void locale.value
  return getAuthMethodLabel(t)
})
const customCols = computed<TableOptColumn[]>(() => {
  void locale.value
  return [
    { label: t('remoteAuth.executeTime'), prop: 'frequency', columnOpt: { minWidth: 150 } },
    { label: t('remoteAuth.authMethod'), width: 130, prop: 'auth_type', formatter: (row, value, column) => authMethodLabel.value[row.strategy.auth_type] },
    { label: t('remoteAuth.ipWhitelist'), prop: 'ip_whitelist', columnOpt: { minWidth: 130 } },
  ]
})

const logDrawerVisible = ref(false)
const logDrawerListKey = ref(0)
const logDrawerInitialDateEmpty = ref(false)
const logDrawerInitialTimeRangeUnix = ref<[number, number] | undefined>(undefined)
const logDrawerInitialKeyword = ref<string | undefined>(undefined)
const logDrawerInitialGroupId = ref<string | undefined>(undefined)

function resetLogDrawerEmbed() {
  logDrawerInitialDateEmpty.value = false
  logDrawerInitialTimeRangeUnix.value = undefined
  logDrawerInitialKeyword.value = undefined
  logDrawerInitialGroupId.value = undefined
}

const handleViewAllLogs = () => {
  if (!hasPermission) return
  resetLogDrawerEmbed()
  logDrawerListKey.value += 1
  logDrawerVisible.value = true
}

/** 排行区「查看全部」与卡片「查看全部」一致：全量日志抽屉默认近三个月、无预填条件 */
const handleViewAllRanking = handleViewAllLogs

/** 登录次数排行点击：全部则不限制时间；否则与排行时间一致；关键字/分组与终端一致 */
function handleLoginRankingRowClick(payload: {
  count: number
  chartTimeRange: TimeRange
  computerName: string
  groupId?: string
}) {
  if (payload.count <= 0) return
  logDrawerInitialKeyword.value = payload.computerName
  logDrawerInitialGroupId.value =
    payload.groupId !== undefined && payload.groupId !== '' ? payload.groupId : undefined
  if (payload.chartTimeRange === TimeRange.ALL) {
    logDrawerInitialDateEmpty.value = true
    logDrawerInitialTimeRangeUnix.value = undefined
  } else {
    logDrawerInitialDateEmpty.value = false
    const [startSec, endSec] = getTimeRangeByEnum(payload.chartTimeRange)
    if (startSec !== undefined && endSec !== undefined) {
      logDrawerInitialTimeRangeUnix.value = [startSec, endSec]
    } else {
      logDrawerInitialDateEmpty.value = true
      logDrawerInitialTimeRangeUnix.value = undefined
    }
  }
  logDrawerListKey.value += 1
  logDrawerVisible.value = true
}

// 策略相关处理函数
const handlePolicyAction = ({ type, ...other }: { type: string;[type: string]: any; }) => {
  const { validGroupId } = policyManageRef.value
  const types: any = {
    add: () => {
      visible.value = true
      activeRow.value = {} as StrategyListDataCommon
      fromGroupId.value = validGroupId
    },
    edit: async () => {
      visible.value = true
      activeRow.value = other.rowItem
      fromGroupId.value = undefined
    },
  }
  types?.[type]?.()
}

const handlePolicySelected = (selected: any[]) => {
  selectedPolicyIds.value = selected.map(item => item.id)
}

const handleDeletePolicy = () => {
  // TODO: 删除策略
  ElMessage.success(t('remoteAuth.deletePolicyTodo'))
}

const handleShowTokenCode = () => {
  visibleToken.value = true
}
// 获取动态口令二维码
async function fetchBindQrcode(id: string) {
  qrcodeLoading.value = true
  try {
    const res = await getStrategyRemoteLoginAuthBindDynamicPasswordApi({ id })
    bindUrl.value = res.bind_url || ''
    lastUpdateTime.value = dayjs(res.create_timestamp * 1000).format('YYYY-MM-DD HH:mm:ss')
  } finally {
    qrcodeLoading.value = false
  }
}
// 重新生成二维码
async function handleRefreshQrcode() {
  if (!currentStrategyId.value) return
  bindUrl.value = ''
  refreshLoading.value = true
  try {
    const res = await getStrategyRemoteLoginAuthRefreshDynamicPasswordApi({ id: currentStrategyId.value })
    lastUpdateTime.value = dayjs(res.create_timestamp * 1000).format('YYYY-MM-DD HH:mm:ss')
    await fetchBindQrcode(currentStrategyId.value)
  } finally {
    refreshLoading.value = false
  }
}

async function openDynamicTokenDialog(id: string, strategyName: string) {
  currentStrategyId.value = id
  name.value = strategyName
  visibleToken.value = true
  await fetchBindQrcode(id)
}

/** 列表接口里 auth_type 可能是字符串，与枚举比较前统一成数字 */
function isAuthCodeRow(row: { strategy?: { auth_type?: number | string } }) {
  return Number(row?.strategy?.auth_type) === Auth_method.auth_code
}

async function fetchPolicyPasswordForRow(id: string): Promise<string> {
  try {
    const res: any = await getApi({ id, type: PolicySettingType.remote_login_auth })
    const p = res?.strategy?.password
    return typeof p === 'string' ? p : ''
  } catch {
    return ''
  }
}

const getPrefixActButtons = ({ id, ...rest }) => {
  const isAuthCode = Number(rest?.strategy?.auth_type) === Auth_method.auth_code
  return [
    {
      name: isAuthCode ? t('remoteAuth.tokenBtn') : t('remoteAuth.showPasswordLink'),
      type: 'dynamic-token',
      opt: { size: 'small', type: 'primary' },
      events: {
        async click() {
          if (!isAuthCode) return
          await openDynamicTokenDialog(id, rest.name)
        }
      }
    },
  ]
}

const policyPrefixActButtons = (params: Parameters<typeof getPrefixActButtons>[0]) =>
  IS_JP_ONLY_BUILD ? [] : getPrefixActButtons(params)

const submit = (id: string, strategyName: string) => {
  void openDynamicTokenDialog(id, strategyName)
}
function handleRefresh() {
  groupRefreshManage.refreshGroup()
  policyManageRef.value.tableRef.getList()
}

// 加载统计数据
async function loadStatistics() {
  if (!hasPermission) return

  try {
    // 获取今日的时间范围（从今天0点到现在）
    const now = Math.floor(dayjs().valueOf() / 1000)
    const todayStart = Math.floor(dayjs().startOf('day').valueOf() / 1000)

    const res = await remoteAuthLoginService.getTerminalRemoteLoginOverviewStat({
      start_time: todayStart.toString(),
      end_time: now.toString()
    })

    statistics.todayLoginCount = res.today_total_login_count || 0
    statistics.todaySuccessCount = res.today_login_success_count || 0
    statistics.todayFailedCount = res.today_login_fail_count || 0
  } catch (error) {
    console.error('加载统计数据失败:', error)
  }
}

// 加载趋势图数据
async function loadTrendData() {
  if (!hasPermission) return

  try {
    const [start_time, end_time] = getTimeRangeByEnum(trendTimeRange.value)
    const granularity = TimeGranularity[trendTimeRange.value] || 'hour'

    const res = await remoteAuthLoginService.getTerminalRemoteLoginTrendStat({
      start_time: start_time.toString(),
      end_time: end_time.toString(),
      granularity
    })

    const timePoints = res.time_points || []
    const successCounts = res.login_success_list || []
    const failCounts = res.login_fail_list || []

    // 格式化时间点
    const times = timePoints.map((timestamp: string) => {
      return formatTimeStamp(timestamp, TimeFormat[trendTimeRange.value])
    })

    trendChartData.value = {
      times,
      success: successCounts,
      failed: failCounts
    }
  } catch (error) {
    console.error('加载趋势图数据失败:', error)
    trendChartData.value = {
      times: [],
      success: [],
      failed: []
    }
  }
}

// 加载排行数据
async function loadRankingData() {
  if (!hasPermission) return

  if (loginRankingChartRef.value) {
    loginRankingChartRef.value.loading = true
  }
  try {
    const params: terminalStatTopRequestParams = { top_count: 5 }
    const [start_time, end_time] = getTimeRangeByEnum(rankingTimeRange.value)
    if (start_time !== undefined && end_time !== undefined) {
      params.start_time = start_time.toString()
      params.end_time = end_time.toString()
    }

    const res = await remoteAuthLoginService.getTerminalRemoteLoginTopTerminalStat(params)

    rankingData.value = (res.top_terminal_list || []).map((item) => ({
      name: item.computer_name || t('remoteAuth.unknown'),
      department: item.department || t('remoteAuth.unknown'),
      count: item.login_count || 0,
      device_id: item.device_id,
      group_id: item.group_id,
    }))
  } catch (error) {
    console.error('加载排行数据失败:', error)
    rankingData.value = []
  } finally {
    if (loginRankingChartRef.value) {
      loginRankingChartRef.value.loading = false
    }
  }
}

// 监听时间范围变化
watch(trendTimeRange, () => {
  loadTrendData()
})

watch(rankingTimeRange, () => {
  loadRankingData()
})

onMounted(() => {
  if (hasPermission) {
    loadStatistics()
    loadTrendData()
    loadRankingData()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageSubscribeBar, {
      "normal-permission-key": _unref(PermissionFe).remote_control
    }, null, 8, ["normal-permission-key"]),
    _createVNode(StatisticsCards, {
      "today-login-count": statistics.todayLoginCount,
      "today-success-count": statistics.todaySuccessCount,
      "today-failed-count": statistics.todayFailedCount
    }, null, 8, ["today-login-count", "today-success-count", "today-failed-count"]),
    _createVNode(_component_el_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 18,
          style: {"height":"380px"}
        }, {
          default: _withCtx(() => [
            _createVNode(LoginTrendChart, {
              "time-range": trendTimeRange.value,
              "onUpdate:timeRange": _cache[0] || (_cache[0] = ($event: any) => ((trendTimeRange).value = $event)),
              data: trendChartData.value
            }, null, 8, ["time-range", "data"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(LoginRankingChart, {
              ref_key: "loginRankingChartRef",
              ref: loginRankingChartRef,
              "time-range": rankingTimeRange.value,
              "onUpdate:timeRange": _cache[1] || (_cache[1] = ($event: any) => ((rankingTimeRange).value = $event)),
              data: rankingData.value,
              onViewAll: _unref(handleViewAllRanking),
              onRowClick: handleLoginRankingRowClick
            }, null, 8, ["time-range", "data", "onViewAll"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(Card, {
      title: _ctx.$t('remoteAuth.remoteLoginLogTitle'),
      class: "cm-ui-mt16 cm-ui-mb16",
      onViewMore: handleViewAllLogs,
      "view-more-disabled": !_unref(hasPermission),
      viewMoreText: _ctx.$t('remoteAuth.viewAll'),
      viewMoreButtonType: ""
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(RemoteLoginLogList, {
          ref_key: "remoteLoginLogListRef",
          ref: remoteLoginLogListRef
        }, null, 512)
      ]),
      _: 1
    }, 8, ["title", "view-more-disabled", "viewMoreText"]),
    _createVNode(PolicyManage, {
      title: _ctx.$t('remoteAuth.policyList'),
      ref_key: "policyManageRef",
      ref: policyManageRef,
      "normal-permission-key": _unref(PermissionFe).remote_control,
      triggerTime: "none",
      prefixActButtons: policyPrefixActButtons,
      actWidth: 200,
      "strategy-type": _unref(PolicyType).remote_login_auth,
      "custom-cols": customCols.value,
      "data-type": _unref(PolicySettingType).remote_login_auth,
      "show-group-selector": true,
      "terminal-type": [_unref(TerminalType).windows, _unref(TerminalType).windowsServer],
      "enable-drag-sort": false,
      "show-usage-help": false,
      onHandleAction: handlePolicyAction,
      onChangeSelected: handlePolicySelected
    }, {
      "dynamic-token-link-action": _withCtx(({ row, item }) => [
        (isAuthCodeRow(row))
          ? (_openBlock(), _createBlock(_component_el_link, _mergeProps({ key: 0 }, item.opt, {
              underline: false,
              size: "small",
              onClick: _withModifiers(() => openDynamicTokenDialog(row.id, row.name), ["prevent","stop"])
            }), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1040, ["onClick"]))
          : (_openBlock(), _createBlock(RemoteAuthPolicyPasswordLink, {
              key: 1,
              password: row.strategy?.password,
              "load-password": () => fetchPolicyPasswordForRow(row.id)
            }, null, 8, ["password", "load-password"]))
      ]),
      table__frequency: _withCtx(({ row }) => [
        _createVNode(TaskTimeShow, {
          frequency: row.strategy.frequency,
          "task-time": row.strategy.regular_tasks
        }, null, 8, ["frequency", "task-time"])
      ]),
      table__ip_whitelist: _withCtx(({ row }) => [
        _createVNode(Keywords, {
          "max-count": 1,
          maxChars: 20,
          keywords: row.strategy.ip_whitelist,
          stringType: ""
        }, null, 8, ["keywords"])
      ]),
      "prefix-action": _withCtx(() => [
        (!_unref(IS_JP_ONLY_BUILD))
          ? (_openBlock(), _createBlock(TokenCode, {
              key: 0,
              class: "cm-ui-mr10"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "normal-permission-key", "strategy-type", "custom-cols", "data-type", "terminal-type"]),
    _createVNode(_component_el_drawer, {
      size: "75%",
      title: _ctx.$t('remoteAuth.strategySetting'),
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(StrategySetting, {
          modelValue: visible.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
          onRefresh: handleRefresh,
          hasPermission: _unref(hasPermission),
          api: { getApi: _unref(getApi), saveOrUpdateApi: _unref(saveOrUpdateApi) },
          id: activeRow.value.id,
          "from-group-id": fromGroupId.value,
          onSubmit: submit
        }, null, 8, ["modelValue", "hasPermission", "api", "id", "from-group-id"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_drawer, {
      size: "80%",
      title: _ctx.$t('remoteAuth.allRemoteLoginLogTitle'),
      modelValue: logDrawerVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((logDrawerVisible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(RemoteLoginLogList, {
          key: logDrawerListKey.value,
          viewMode: _unref(TableViewMode).full,
          "initial-date-empty": logDrawerInitialDateEmpty.value,
          "initial-time-range-unix": logDrawerInitialTimeRangeUnix.value,
          "initial-keyword": logDrawerInitialKeyword.value,
          "initial-group-id": logDrawerInitialGroupId.value,
          style: {"padding":"10px 16px"}
        }, null, 8, ["viewMode", "initial-date-empty", "initial-time-range-unix", "initial-keyword", "initial-group-id"]))
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    (!_unref(IS_JP_ONLY_BUILD))
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: visibleToken.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((visibleToken).value = $event)),
          width: 500
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('remoteAuth.tokenQrTitle')) + "-", 1),
            _createElementVNode("span", _hoisted_1, _toDisplayString(name.value), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(TokenCode, { tooltipOpt: { placement: 'right', offset: -120 } }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_2, [
                  _createVNode(_component_i18n_t, {
                    keypath: "remoteAuth.tokenAppTip",
                    tag: "span"
                  }, {
                    highlight: _withCtx(() => [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('remoteAuth.tokenAppTipHighlight')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('remoteAuth.scanToBind')), 1),
            _createElementVNode("div", _hoisted_5, [
              (bindUrl.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(QrcodeVue, {
                      value: bindUrl.value,
                      size: 145,
                      level: "M"
                    }, null, 8, ["value"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (qrcodeLoading.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('remoteAuth.loading')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('remoteAuth.noQrcode')), 1))
                  ]))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_button, {
                type: "text",
                onClick: handleRefreshQrcode,
                loading: refreshLoading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('remoteAuth.regenerate')), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('remoteAuth.lastUpdate')) + _toDisplayString(lastUpdateTime.value), 1),
            _createElementVNode("p", _hoisted_12, [
              (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_16)),
              _createTextVNode(_toDisplayString(_ctx.$t('remoteAuth.regenerateTip')), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})